import { AccountData } from '../../types'

export type IdentityCompanyInfoResponse = Partial<AccountData> & {
  company_name?: string
  company_industry?: string
  company_website?: string
  companyIndustry?: string
  companyWebsite?: string
}

type CompanyInfoFormValues = {
  companyName: string
  industry: string
  websiteURL: string
}

type NormalizeCompanyInfoPartnerUpdateArgs = {
  identityPartner: IdentityCompanyInfoResponse | undefined
  formValues: CompanyInfoFormValues
  subscribedProducts: AccountData['subscribedProducts']
}

export const getNormalizedCompanyInfoPartnerUpdate = ({
  identityPartner,
  formValues,
  subscribedProducts,
}: NormalizeCompanyInfoPartnerUpdateArgs) => {
  const data = identityPartner ?? {}

  return {
    ...data,
    companyName:
      data.company_name ?? data.companyName ?? formValues.companyName,
    industry:
      data.company_industry ?? data.companyIndustry ?? formValues.industry,
    websiteUrl:
      data.company_website ?? data.companyWebsite ?? formValues.websiteURL,
    subscribedProducts,
  }
}
